import { useState, useEffect, Fragment } from "react"
import "./AppNav.css"
import InnerNav from "../../../../components/InnerNav/InnerNav"
import type { MenuProps } from "antd"
import AppKeys from "../AppKeys&SDK/AppKeys"
import AppSettings from "../AppSettings/AppSettings"
import EmailNav from "../Email/EmailNav/EmailNav"
import SMS from "../SMS/SMS"
import SecurityNav from "../Security/SecurityNav"
import KillSwitch from "../KillSwitch/KillSwitch"
import Channel from "../Channel/Channel"
import AppInbox from "../AppInbox/AppInbox"
import FileEncryption from "../FileEncryption/FileEncryption"
import CampaignActivationEmail from "../CampaignActivationEmail/CampaignActivationEmail"
import PushNotificationSetting from "../PushNotificationSetting/PushNotificationSetting"
import Features from "../Features/Features"
import PushNotification from "../PushNotification/PushNotification"
import Partner from "../Partner/Partner"
import AllowList from "../AllowList/AllowList"
import { t } from "i18next"
import React from "react"
import CampaignAnalyticsNav from "../CampaignAnalytics/CampaignAnalyticsNav/CampaignAnalyticsNav"
import ApiGatewayNav from "../ApiGateway/ApiGatewayNav/ApiGatewayNav"
import CampaignConfigurator from "../CampaignConfigurator/CampaignConfigurator"
import SiteSettings from "../SiteSettings/SiteSettings"
import { AppNavSettingEnum } from "utils/enums"
import {  useSelector } from "react-redux"
import Logs from "../Logs/Logs"
import Infrastructure from "../Infrastructure/ InfrastructureNav"

import ProviderSetting from "../ProviderSetting/ProviderSetting"
import AuditConfiguratorNav from "../AuditConfigurator/AuditConfiguratorNav/AuditConfiguratorNav"
import AttributionNav from "../Attribution/AttributionNav/AttributionNav"
import GoogleMapKey from "../GoogleMapKey/GoogleMapKey"
import APM from "../APM/APM"
import Channels from "../Channels/Channels"
import Budget from "../Budget/Budget"
import FunnelStepsLimit from "../Analytics/Funnel/FunnelSteps/FunnelStepsLimit"
import RateLimit from "../RateLimit/RateLimit"
import CampaignThreshold from "../CampaignSetting/CampaignThreshold/CampaignThreshold"

import StaggeredSend from "../StaggeredSend/StaggeredSend"
import LangId from "../LangId/LangId"
import Engagement from "../Engagement/Engagement";
interface AppNavProps {
  currentAppKey: string
  smsConfigUn: string
  smsConfigPs: string
  updateCurrentAppKey: any // Add this line
}
const AppNav: React.FC<AppNavProps> = ({
  currentAppKey,
  updateCurrentAppKey,
  smsConfigUn,
  smsConfigPs,
}) => {
  const [appTabFilter, setAppTabFilter] = useState(AppNavSettingEnum.APP_KEYS)
  const [selectedComponent, setSelectedComponent] =
    useState<JSX.Element | null>(null)

  const onTabClick: MenuProps["onClick"] = (e:any) => {
    setAppTabFilter(e.key)
  }
 

  const features = useSelector((state: any) => state.featuresSetting.data);
  const featuresSetting = features[0]?.features;


  useEffect(() => {
    switch (appTabFilter) {
      case AppNavSettingEnum.APP_KEYS:
        setSelectedComponent(<AppKeys currentAppKey={currentAppKey} />)
        break
        case AppNavSettingEnum.API_GATEWAY:

        setSelectedComponent(
       
          <ApiGatewayNav currentAppKey={currentAppKey}
          updateCurrentAppKey={updateCurrentAppKey}
        />
        )
        break
      case AppNavSettingEnum.APP_SETTINGS:
        setSelectedComponent(<AppSettings currentAppKey={currentAppKey} />)
        break
      case AppNavSettingEnum.EMAIL:
        setSelectedComponent(
          <EmailNav
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.SMS:
        setSelectedComponent(
          <SMS
            smsConfigUn={smsConfigUn}
            smsConfigPs={smsConfigPs}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.SECURITY:
        setSelectedComponent(
          <SecurityNav
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.KILL_SWITCH:
        setSelectedComponent(<KillSwitch />)
        break
      case AppNavSettingEnum.CHANNEL:
        setSelectedComponent(
          <Channel
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.APP_INBOX:
        setSelectedComponent(
          <AppInbox
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.FILE_ENCRYPTION:
        setSelectedComponent(
          <FileEncryption
          />
        )
        break
        case AppNavSettingEnum.CampaignActivationEmail:
        setSelectedComponent(
          <CampaignActivationEmail
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
        case AppNavSettingEnum.INFRASTRUCTURE:
          setSelectedComponent(
            <Infrastructure
              currentAppKey={currentAppKey}
              updateCurrentAppKey={updateCurrentAppKey}
            />
          )
          break
      case AppNavSettingEnum.PARTNER_SETTING:
        setSelectedComponent(
          <Partner
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.ALLOWLIST_SETTING:
        setSelectedComponent(
          <AllowList
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
        case AppNavSettingEnum.PROVIDER_SETTING:
          setSelectedComponent(
            <ProviderSetting
              currentAppKey={currentAppKey}
              updateCurrentAppKey={updateCurrentAppKey}
            />
          )
          break
     
      case AppNavSettingEnum.PUSH_NOTIFICATION_SETTINGS:
        setSelectedComponent(
          <PushNotificationSetting
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
        break
      case AppNavSettingEnum.FEATURES:
        setSelectedComponent(<Features />)
        break
      case AppNavSettingEnum.PUSH_NOTIFICATION:
        setSelectedComponent(<PushNotification />)
        break
        case AppNavSettingEnum.LOGS:
          setSelectedComponent(<Logs />)
          break
      case AppNavSettingEnum.CAMPAIGN_ANALYTICS:
        setSelectedComponent(
          <CampaignAnalyticsNav
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
          />
        )
      
        break
        case AppNavSettingEnum.AUDIT_LOGS_CAMPAIGN_CONFIGURATOR:
          setSelectedComponent(
            <AuditConfiguratorNav
              currentAppKey={currentAppKey}
              updateCurrentAppKey={updateCurrentAppKey}
            />
          )
        
          break
          case AppNavSettingEnum.ATTRIBUTION:
            setSelectedComponent(
              <AttributionNav
              currentAppKey={currentAppKey}
              updateCurrentAppKey={updateCurrentAppKey}
              />
            )
            break
      
          case AppNavSettingEnum.CAMPAIGN_CONFIGURATOR:
          setSelectedComponent(
            <CampaignConfigurator
              currentAppKey={currentAppKey}
              // updateCurrentAppKey={updateCurrentAppKey}
            />
          )
          break
          case AppNavSettingEnum.SITE_SETTING:
          setSelectedComponent(
            <SiteSettings
            />
          )
          break
          case AppNavSettingEnum.GEO_SETTINGS:
          setSelectedComponent(
            <GoogleMapKey/>
          )
          break
           case AppNavSettingEnum.APM_SETTINGS:
          setSelectedComponent(
            <APM/>
          )
          break
          case AppNavSettingEnum.CHANNELS:
            setSelectedComponent(
              <Channels currentAppKey={currentAppKey}
              fetchCurrentAppKeys={updateCurrentAppKey}
            />
            )
          break
          case AppNavSettingEnum.BUDGET:
          setSelectedComponent(
            <Budget/>
            
          )
          break
          case AppNavSettingEnum.RATE_LIMIT:
            setSelectedComponent(
              <RateLimit/>
              
            )
          break
          case AppNavSettingEnum.STAGGERED_SEND:
            setSelectedComponent(
              <StaggeredSend/>
              
            )
          break
          case AppNavSettingEnum.LANG_ID:
            setSelectedComponent(
              <LangId/>
              
            )
          break
          case AppNavSettingEnum.FUNNEL_STEPS_LIMIT:
            setSelectedComponent(
              <FunnelStepsLimit
             
              />
            )
            break
            case AppNavSettingEnum.CAMPAIGN_THRESHOLD:
              setSelectedComponent(
                <CampaignThreshold
               />            )
              break
      case AppNavSettingEnum.ENGAGEMENT:
        setSelectedComponent(<Engagement currentAppKey={currentAppKey} fetchCurrentAppKeys={updateCurrentAppKey}/>);
        break;
      // Add cases for other tabs
      default:
        setSelectedComponent(<div></div>) // Default empty component
    }
  }, [appTabFilter, currentAppKey])

  return (
    <Fragment>
      <div className="app-setting-container ">
        <div className="app-setting-nav">
          <InnerNav
            theme="light"
            onTabClick={onTabClick}
            selected={appTabFilter}
            menu={[
              {
                label: t("appKeysLabel"),
                key: AppNavSettingEnum.APP_KEYS,
              },

              { label:t("engagementLabel"), key: AppNavSettingEnum.ENGAGEMENT },

              {
                label: t("analyticsLabel"),
                key: AppNavSettingEnum.ANALYTICS,
                children: [
                  { label:t("funnelLabel"), key: AppNavSettingEnum.FUNNEL_STEPS_LIMIT },

                     
                    ]
              },
            
              {
                label: t("appSettingLabel"),
                key: AppNavSettingEnum.APP_SETTINGS,

              },

              {
                label: t("securityLabel"),
                key: AppNavSettingEnum.SECURITY,
              },
             
              {
                label: t("featuresLabel"),
                key: AppNavSettingEnum.FEATURES,
              },
              {
                label: t("infrastructureLabel"),
                key: AppNavSettingEnum.INFRASTRUCTURE,
              },
            
              {
                label: t("attributionLabel"),
                key: AppNavSettingEnum.ATTRIBUTION,
              },
           
          
               // Rendered only when when its not checked in
             
                    
              {
                label: t("siteSettingLabel"),
                key: AppNavSettingEnum.SITE_SETTING,
              },
              {
                label: t("apmSettingsLabel"),
                key: AppNavSettingEnum.APM_SETTINGS,
              }
            ]}
          />
        </div>
      </div>
      {selectedComponent}
    </Fragment>
  )
}
export default AppNav
